import { computed } from 'vue';
import { gql } from '@apollo/client/core';
import { useQuery } from '@vue/apollo-composable';
import { Query } from '@/graphql/API';
import { getUserDetails } from '@/graphql/queries';
import type { ComputedRef } from 'vue';
import type { OperationVariables } from '@apollo/client/core';
import type { UseQueryReturn } from '@vue/apollo-composable';

const document = gql(getUserDetails);

type QueryResult = {
  getUserDetails: Query['getUserDetails'];
};

type UseGetUserDetailsReturn = UseQueryReturn<
  QueryResult,
  OperationVariables
> & {
  useGetUserDetailsRes: ComputedRef<Query['getUserDetails']>;
};

export function useGetUserDetails(): UseGetUserDetailsReturn {
  const API = useQuery<QueryResult>(document, {});

  const useGetUserDetailsRes = computed(() => API.result.value?.getUserDetails);
  return {
    ...API,
    useGetUserDetailsRes,
  };
}
